import type { ResponseEnvelope } from '#layers/base/public';
import { useSystemFetch } from '#layers/base/public';

/**
 * API functions for creating API keys.
 * Uses direct fetch instead of rstore
 */

export interface CreateApiKeyPayload {
	userId: string;
	name: string;
	ttl: string;
	description?: string;
}

export interface CreateApiKeyResponse {
	id: string;
	key: string;
}

/**
 * Create an API key.
 *
 * @returns The created key ID and the secret token (only returned once)
 */
export async function createApiKey(payload: CreateApiKeyPayload): Promise<CreateApiKeyResponse> {
	const fetch = useSystemFetch();

	const { data } = await fetch<ResponseEnvelope<CreateApiKeyResponse>>('system/api-keys', {
		method: 'POST',
		body: payload,
	});

	return data;
}
